var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scales-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2 17.5V17.3498C2 17.0333 2 16.8751 2.02421 16.7209C2.0457 16.584 2.08136 16.4497 2.13061 16.3202C2.18609 16.1743 2.2646 16.0369 2.42162 15.7622L6 9.5M2 17.5C2 19.7091 3.79086 21.5 6 21.5C8.20914 21.5 10 19.7091 10 17.5M2 17.5V17.3C2 17.02 2 16.88 2.0545 16.773C2.10243 16.6789 2.17892 16.6024 2.273 16.5545C2.37996 16.5 2.51997 16.5 2.8 16.5H9.2C9.48003 16.5 9.62004 16.5 9.727 16.5545C9.82108 16.6024 9.89757 16.6789 9.9455 16.773C10 16.88 10 17.02 10 17.3V17.5M6 9.5L9.57838 15.7622C9.7354 16.0369 9.81391 16.1743 9.86939 16.3202C9.91864 16.4497 9.9543 16.584 9.97579 16.7209C10 16.8751 10 17.0333 10 17.3498V17.5M6 9.5L18 7.5M14 15.5V15.3498C14 15.0333 14 14.8751 14.0242 14.7209C14.0457 14.584 14.0814 14.4497 14.1306 14.3202C14.1861 14.1743 14.2646 14.0369 14.4216 13.7622L18 7.5M14 15.5C14 17.7091 15.7909 19.5 18 19.5C20.2091 19.5 22 17.7091 22 15.5M14 15.5V15.3C14 15.02 14 14.88 14.0545 14.773C14.1024 14.6789 14.1789 14.6024 14.273 14.5545C14.38 14.5 14.52 14.5 14.8 14.5H21.2C21.48 14.5 21.62 14.5 21.727 14.5545C21.8211 14.6024 21.8976 14.6789 21.9455 14.773C22 14.88 22 15.02 22 15.3V15.5M18 7.5L21.5784 13.7622C21.7354 14.0369 21.8139 14.1743 21.8694 14.3202C21.9186 14.4497 21.9543 14.584 21.9758 14.7209C22 14.8751 22 15.0333 22 15.3498V15.5M12 3.5V8.5",
    stroke: "#1A1A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScales);
export default __webpack_public_path__ + "static/media/scales.da9cb699d1cdf4a871f0803eb3b01596.svg";
export { ForwardRef as ReactComponent };